import { Button } from '@mantine/core';
import { modals } from '@mantine/modals';
import { i18nKeys, useTranslation } from 'locales';
import type { ComponentProps } from 'react';

import { Right } from './Right';

interface ModalFooterProps {
  onCancel?: VoidFunction;
  onSave: VoidFunction;
  // On some modals, we remove the body padding to achieve a flush effect on the content, but the footer
  // still needs some spacing from the edge.
  isLoading?: boolean;
  withOwnPadding?: boolean;
  isDisabled?: boolean;
  onCancelProps?: ComponentProps<typeof Button>;
  onSaveProps?: ComponentProps<typeof Button>;
}

export const ModalFooter = ({
  onCancel,
  onSave,
  isLoading = false,
  isDisabled = false,
  withOwnPadding = false,
  onCancelProps,
  onSaveProps,
}: ModalFooterProps) => {
  const { t } = useTranslation();

  return (
    <Right gap="md" w="100%" mt="md" pr={withOwnPadding ? 'md' : '0px'}>
      <Button
        color="warning"
        variant="subtle"
        onClick={onCancel ?? modals.closeAll}
        disabled={isLoading}
        children={t(i18nKeys.CANCEL)}
        {...onCancelProps}
      />
      <Button
        disabled={isDisabled}
        color="purple"
        onClick={onSave}
        loading={isLoading}
        children={t(i18nKeys.SAVE)}
        {...onSaveProps}
      />
    </Right>
  );
};
